import React from "react";

const CompanyProfileHeader = ({ Image, Heading }) => {
  return (
    <div className="grid items-end mx-auto">
      <div className="font-bold text-[20px] sm:text-[22px] md:text-[36px] col-start-1 col-end-8 text-left ">
        {Heading}
      </div>
      <Image className=" col-start-9 col-end-12 " />
    </div>
  );
};

export default CompanyProfileHeader;
